import React from 'react';
import classnames from 'classnames';
import {getBackgroundImg, getPublicImagePath} from "@nutastic/nutastic-react-app";

const LinksPage = ({pageIndex, pageContent, useIcons}) => {
    const componentClass = "linksPage";
    const pageId = pageContent && pageContent.hasOwnProperty('pageId') ? pageContent.pageId : null;
    const { image, title, subtitle, links = [] } = pageContent;
    const classes = classnames(componentClass, {
        [`${componentClass}--${pageId}`]: !!pageId,
        [`${componentClass}--${pageIndex}`]: !!pageIndex
    });

    const headerBgImage = getBackgroundImg(getPublicImagePath(image));

    const linkButtonsRender = links.map((link, i) => {
        const cssClass = "linksPageButton";
        const linkClasses = classnames(cssClass, {
           [`${cssClass}--withIcons`]: useIcons,
        });
        const { title: linkTitle, details: linkDetails, iconClass, href = "#!" } = link;
        return <a className={linkClasses} key={i} href={href} target="_blank">
            { (useIcons && iconClass) && <div className={`${cssClass}__icon`}><i className={iconClass} /></div> }
            <div className={`${cssClass}__linkDetails`}>
                <h5>{ linkTitle }</h5>
                { linkDetails && <span>{ linkDetails }</span> }
            </div>
        </a>
    });

    return <main className={classes}>
        <div className={`${componentClass}__header animated fadeInDown`} style={headerBgImage}>
            <img src={getPublicImagePath('sqaure_transparent.png')} />
        </div>
        <div className={`${componentClass}__info animated fadeIn`}>
            <h2>{ title }</h2>
            { subtitle && <p>{ subtitle }</p> }
        </div>
        <div className={`${componentClass}__buttons animated fadeInUp`}>
            { linkButtonsRender }
        </div>
    </main>;
};

export default LinksPage;
